"use client";

import { ArrowUpRight } from "lucide-react";
import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Image from "next/image";
import { scrollToSection } from "@/lib/utils";

const LeftTopSection = () => {
  const [text, setText] = useState("Designs that Move Ideas Forward.");
  const texts = React.useMemo(
    () => [
      "Designs that Move Ideas Forward.",
      "Bringing Your Vision to Life, Digitally.",
      "Designing the Future of Your Brand.",
      "Transforming Ideas into Digital Impact.",
    ],
    []
  );
  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      index = (index + 1) % texts.length;
      setText(texts[index]);
    }, 5000);
    return () => clearInterval(interval);
  }, [texts]);

  return (
    <div className="relative px-4 sm:px-0">
      <div className="relative sm:w-[576px] sm:h-[390px] w-full h-[280px] overflow-hidden rounded-[15px]">
        <Image
          src="/images/LeftTopSection.svg"
          alt="Left Top Container"
          fill
          className="object-cover rounded-[15px]"
          priority
        />
      </div>
      <section className="absolute top-2 sm:left-1 ml-1.5 sm:ml-0">
        <motion.div
          animate={{
            rotate: [0, 40, 40, 0],
          }}
          transition={{
            duration: 4,
            times: [0, 0.25, 0.75, 1],
            ease: "easeInOut",
            repeat: Infinity,
            repeatDelay: 1,
          }}
        >
          <section className="sm:block">
            <Image
              src="/images/Ellipse.png"
              width={380}
              height={380}
              alt="Picture of the author"
              className="sm:w-[380px] sm:h-[380px] w-[250px] h-[260px]"
            />
          </section>
        </motion.div>
      </section>
      <motion.section
        className="absolute sm:left-4.5 ml-4.5 sm:ml-0 top-0 pr-8 sm:pr-3 pt-2 sm:text-[74px] sm:leading-[93px] text-[44px] leading-[46px] text-white"
        initial={{ y: 55, opacity: 0 }}
        animate={{
          y: [55, 0, 0, 0],
          opacity: [0, 1, 1, 0],
        }}
        transition={{
          duration: 4,
          times: [0, 0.25, 0.75, 1],
          ease: "easeInOut",
          repeat: Infinity,
          repeatDelay: 1,
        }}
      >
        {text}
      </motion.section>
      <section className="absolute bottom-0 p-5">
        <div className="flex items-start sm:items-center justify-center sm:gap-8 gap-4">
          <p className="sm:text-[19.2px] text-[16px] pr-5 sm:pr-8 leading-6 font-extralight capitalize text-white">
            We craft digital experiences with purpose blending clarity,
            creativity, and strategy to help your product thrive.
          </p>
          <div
            onClick={() => {
              const isMobile = window.innerWidth < 740;
              const targetId = isMobile ? "design-workk" : "design-work";
              scrollToSection(targetId);
            }}
            className="group bg-white h-[43px] min-w-11 max-w-11 sm:h-12 sm:min-w-12 cursor-pointer relative -left-3  sm:-left-8 top-5 sm:-top-2 font-extralight text-primary rounded-full flex items-center justify-center overflow-hidden"
          >
            <div className="absolute inset-0 rounded-full bg-primary-sky transform translate-x-[-100%] translate-y-[100%] transition-transform duration-300 ease-in-out group-hover:translate-x-0 group-hover:translate-y-0" />
            <ArrowUpRight
              className="text-black absolute transform transition-transform duration-300 ease-in-out group-hover:translate-x-[100%] group-hover:translate-y-[-100%] h-12"
              strokeWidth={1.4}
            />
            <ArrowUpRight
              className="text-black absolute transform translate-x-[-100%] translate-y-[100%] transition-transform duration-300 ease-in-out group-hover:translate-x-0 group-hover:translate-y-0 h-12"
              strokeWidth={1.4}
            />
          </div>
        </div>
      </section>
    </div>
  );
};

export default LeftTopSection;
